import * as React from 'react';

// first step in task creation is always inaccessible, this is a placeholder.
export default function EmptyForm(): JSX.Element {
    return <></>;
}
